import Cookies from 'js-cookie';

class CookieBar {
  constructor(options = {}) {
    this.config = {
      expireDays: 365,
      cookiePath: '/',
      module: document.querySelector('[data-module="CookieBar"]'),
      isHttps: window.location.protocol === 'https:',
      ...options
    };
  }

  init() {
    const { module, expireDays, cookiePath, isHttps } = this.config;

    if (!this.config.module) {
      return;
    }

    const setCookies = approvedCookies => {
      Cookies.set('png_consentGiven', 'true', {
        expires: expireDays,
        path: cookiePath,
        secure: isHttps,
        sameSite: isHttps ? 'none' : ''
      });

      if (approvedCookies.length) {
        Cookies.set('png_approvedCookies', approvedCookies.join(','), {
          expires: expireDays,
          path: cookiePath,
          secure: isHttps,
          sameSite: isHttps ? 'none' : ''
        });
      }

      window.location.reload();
    };

    const submit = module.querySelector('[type="submit"]');
    const acceptAll = module.querySelectorAll('[data-accept-all]');

    if (!submit) {
      return;
    }

    submit.addEventListener('click', e => {
      e.preventDefault();

      // only add checked inputs
      const approvedCookies = Array.from(
        module.querySelectorAll('input[type="checkbox"]:checked')
      ).map(checkbox => checkbox.getAttribute('name'));

      setCookies(approvedCookies);
    });

    if (acceptAll) {
      acceptAll.forEach(btn => {
        btn.addEventListener('click', e => {
          e.preventDefault();

          // add all inputs
          const approvedCookies = Array.from(module.querySelectorAll('input[type="checkbox"]')).map(
            checkbox => checkbox.getAttribute('name')
          );

          setCookies(approvedCookies);
        });
      });
    }

    // Trigger more information visibility (mobile)
    const triggerMoreInfo = module.querySelector('[data-child-module="TriggerMoreInfo"]');
    const button = triggerMoreInfo.querySelector('.js-trigger-cookie-more-info');
    const target = triggerMoreInfo.querySelector('.js-cookie-more-info');

    button.addEventListener('click', e => {
      e.preventDefault();
      button.setAttribute('style', 'display:none !important');
      target.setAttribute('style', 'display:block !important');
    });
  }
}

export default CookieBar;
